<!--START: header-->
<landing-app-header></landing-app-header>
<!--END: header-->

<div class="sub-hero-section wf-section">
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div class="margin-20px">
        <h1 data-w-id="b2b8c855-79b7-de28-ffdb-567745601f64" class="hero-title color-white">About Merchloop<span class="add-scribble-below"></span><span class="add-scribble-below"></span><br></h1>
        <div data-w-id="435c1617-ebf5-9125-7fad-91a2d5a60d18" class="tag-text">We are Landkit</div>
      </div>
    </div>
  </div><img src="assets/img/scribbles-3.png" width="60" data-w-id="7213ac48-ade5-7736-1d49-0610b57e33ba" sizes="100vw" srcset="assets/img/scribbles-3-p-500.png 500w, assets/img/scribbles-3.png 608w" alt="" class="scribble-2"><img src="assets/img/scribbles-2.png" width="120" data-w-id="199a9640-26ee-0aec-ee80-cce873b306bb" sizes="(max-width: 991px) 80px, 120px" srcset="assets/img/scribbles-2-p-500.png 500w, assets/img/scribbles-2-p-800.png 800w, assets/img/scribbles-2.png 1036w" alt="" class="scribble-1">
</div>
<div class="section aboutus wf-section">
  <div class="container">
    <div class="carers-grid">
      <div class="carers-photo"><img src="assets/img/scribbles-10.png" width="100" data-w-id="ca2efb65-1ee7-ce25-fece-e844e1711c46" sizes="100px" srcset="assets/img/scribbles-10-p-500.png 500w, assets/img/scribbles-10.png 800w" alt=""></div>
      <div class="carers-block orange">
        <div class="flex-content">
          <div class="margin-20px">
            <h2 class="hero-title _50px color-white">Democratizing<br>Ecommerce<br></h2>
          </div>
          <div class="margin-20px">
            <p class="sub-heading color-white">We believe that anyone should have access to awesome merch! That is why we have built a platform around Made To Order products so you don&#x27;t have to be flushed with cash to get your idea out into the world.<strong><br></strong></p>
          </div>
        </div>
        <div class="margin-20px">
          <a href="../pages/contact.html" class="button about-us w-button">Contact Us →</a>
        </div>
      </div>
    </div>
    <div data-w-id="82bb4f3e-2302-ea0d-c4ae-367ac6e5206d" class="line-divider"></div>
    <div class="margin-50px">
      <div class="gird-photo">
        <div class="photo-about _2"></div>
        <div class="photo-about"></div>
        <div class="photo-about _4"></div>
        <div class="photo-about _3"></div>
        <div class="photo-about _5"></div>
      </div>
    </div>
    <!--<div class="margin-block">
      <div class="counters-block">
        <div class="counters-grid">
          <div class="counters-content">
            <div>100+</div>
            <p class="paragraph-white">Components make any design stand out<br></p>
          </div>
          <div class="counters-content">
            <div>4+</div>
            <p class="paragraph-white">Unique hero sections that can easily be dropped into any section<br></p>
          </div>
          <div class="counters-content">
            <div>99%</div>
            <p class="paragraph-white">Strong team supporting Landkit template<br></p>
          </div>
        </div><img src="assets/img/scribbles-7.png" width="100" data-w-id="e0634edc-c987-6d65-a0c8-6fe5353565e4" sizes="100vw" srcset="assets/img/scribbles-7-p-500.png 500w, assets/img/scribbles-7.png 812w" alt="" class="scribble-1">
      </div>
    </div>
    <div class="margin-block">
      <div class="align-center">
        <h4 class="hero-title _50px">Meet Your Colleagues</h4>
        <div class="margin-15px">
          <p class="sub-heading">Join our global team and enjoy the ride!<br></p>
        </div>
      </div>
      <div class="team-content">
        <div>
          <div class="team-image"></div>
          <h4>John Doe, CEO Founder</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
        <div>
          <div class="team-image _2"></div>
          <h4>John Doe, Designer</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
        <div>
          <div class="team-image _3"></div>
          <h4>John Doe, Developer</h4>
          <div class="margin-15px">
            <p>&quot;As an designer, I love the technical challenges that come with a fast growing company.&quot;<br></p>
          </div>
        </div>
      </div>
      <div data-w-id="499c4eef-09b1-f181-af07-a86d6b64b5d8" class="line-divider"></div>
      <div class="container">
        <div class="logo-grid"><img src="assets/img/logo-3.png" width="150" alt=""><img src="assets/img/logo-2.png" width="140" alt=""><img src="assets/img/logo-6.png" width="140" alt=""><img src="assets/img/logo-5.png" width="140" sizes="100vw" srcset="assets/img/logo-5-p-500.png 500w, assets/img/logo-5.png 2160w" alt=""><img src="assets/img/logo-1.png" width="130" alt=""><img src="assets/img/logo-4.png" width="130" alt=""></div>
      </div>
    </div>-->
  </div>
</div>
<!--START: Footer-->
<landing-app-footer></landing-app-footer>
<!--END: Footer-->
